<template>
    <div class="repayment-container">
        <span class="payment-title">{{ $t('m.rentalInformation') }}</span>
        <ul class="billing-rule-content">
            <li class="item">
                <span>{{ $t('m.rentalNumber') }}</span>
                <span>{{ repaymentInfo.rent_id ? repaymentInfo.rent_id : '-' }}</span>
            </li>
            <li class="item">
                <span>{{ $t('m.rentalLocation') }}</span>
                <span>{{ repaymentInfo.rent_outlets_name ? repaymentInfo.rent_outlets_name : '-' }}</span>
            </li>
            <li class="item">
                <span>{{ $t('m.rentalTime') }}</span>
                <span>{{ formatTimestamp(repaymentInfo.rent_at) }}</span>
            </li>
            <li class="item">
                <span>{{ $t('m.returnTime') }}</span>
                <span>{{ formatTimestamp(repaymentInfo.back_at) }}</span>
            </li>
            <li class="item">
                <span>{{ $t('m.returnLocation') }}</span>
                <span>{{ repaymentInfo.back_outlets_name ? repaymentInfo.back_outlets_name : '-' }}</span>
            </li>
            <li class="item">
                <span>{{ $t('m.rentalDuration') }}</span>
                <span>{{ repaymentInfo.total_time ? repaymentInfo.total_time : '-' }}</span>
            </li>
            <li class="item">
                <span>{{ $t('m.totalAmount') }}</span>
                <span>{{ repaymentInfo.actual_fee ? currencyFormat(parseFloat(repaymentInfo.actual_fee), repaymentInfo.currency) : '-' }}</span>
            </li>
            <li class="item">
                <span>{{ $t('m.paidAmount') }}</span>
                <span>{{ repaymentInfo.success_fee ? currencyFormat(parseFloat(repaymentInfo.success_fee), repaymentInfo.currency) : '-' }}</span>
            </li>
            <li class="item">
                <span class="fee">{{ $t('m.unpaidAmount') }}</span>
                <span class="fee">{{ repaymentInfo.unpaid_fee ? currencyFormat(parseFloat(repaymentInfo.unpaid_fee), repaymentInfo.currency) : '-' }}</span>
            </li>
        </ul>
    </div>
</template>

<script>
import { time2Date } from "@/utils/tool";

export default {
    name: "RepayBillingRuleDisplay",
    props: {
        repaymentInfo: {
            type: Object,
            required: true,
        },
    },
    methods: {
        formatTimestamp(ts) {
            if (!ts) return "-";
            return time2Date(ts, "Y-m-d H:i:s");
        },
    },
};
</script>

<style lang="scss">
@use "@/styles/variables.scss" as *;

.repayment-container {
    width: 343px;
    margin: 20px auto 0;

    .payment-title {
        font-size: 16px;
        font-weight: 600;
        line-height: 19.09px;
        letter-spacing: -0.2px;
    }

    .billing-rule-content {
        list-style: none;
        display: flex;
        flex-direction: column;
        gap: 9px;
        margin: 0;
        margin-top: 9px;
        padding: 15px;
        background: #fff;
        border-radius: 5px;
        box-shadow: 0 1px 21.3px 0 #0000000a;

        .item {
            display: flex;
            justify-content: space-between;
            font-size: 12px;
            line-height: 18.6px;
            color: #666666;

            .fee {
                font-weight: 500;
                color: #555555;
            }
        }
    }
}
</style>
